export * from './register/register.component';
export * from './terms-and-conditions/terms-and-conditions.component';
export * from './register-account-screen/register-account-sccreen';
export * from './register-reception-screen/register-reception-screen.component';
export * from './registration-success/registration-success.component';
export * from '../../@components/processing-loader/processing-loader.component';
export * from './registration-purchase-number-fail/registration-purchase-number-fail.component';
export * from './register-number-chooser/register-number-chooser.component';
export * from './register-payment-screen/register-payment-screen.component';
export * from './registration-confirmation/registration-confirmation.component';
